import { RuleProps } from 'types/application';

export const CONTENT_ASSESSOR_REGISTRATION = 'content-assessor-registration';

export const CONTENT_ASSESSOR_REGISTRATION_FIELDS = [
    {
        sectionID: CONTENT_ASSESSOR_REGISTRATION,
        sectionName: '',
        fieldList: [
            {
                id: 'question-1',
                label: 'Do you have existing criminal record(s) in Singapore or overseas (excluding parking offences or spent records)?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: { required: true },
                span: 12
            },
            {
                id: 'question-1-remarks',
                label: 'Remarks',
                type: 'longText',
                rule: {
                    baseIds: [`${CONTENT_ASSESSOR_REGISTRATION}-question-1`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${CONTENT_ASSESSOR_REGISTRATION}-question-1`] === 'Yes');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${CONTENT_ASSESSOR_REGISTRATION}-question-1`] !== 'Yes');
                        return result;
                    }
                },
                textRows: 4,
                span: 12
            },
            {
                id: 'question-2',
                label: 'Have you been charged with any offence in a court of law in Singapore or in any other country for which the outcome is pending (excluding parking offences)?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: { required: true },
                span: 12
            },
            {
                id: 'question-2-remarks',
                label: 'Remarks',
                type: 'longText',
                rule: {
                    baseIds: [`${CONTENT_ASSESSOR_REGISTRATION}-question-2`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${CONTENT_ASSESSOR_REGISTRATION}-question-2`] === 'Yes');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${CONTENT_ASSESSOR_REGISTRATION}-question-2`] !== 'Yes');
                        return result;
                    }
                },
                textRows: 4,
                span: 12
            },
            {
                id: 'question-3',
                label: 'Are you currently under police investigation in Singapore or overseas?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: { required: true },
                span: 12
            },
            {
                id: 'question-3-remarks',
                label: 'Remarks',
                type: 'longText',
                rule: {
                    baseIds: [`${CONTENT_ASSESSOR_REGISTRATION}-question-3`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${CONTENT_ASSESSOR_REGISTRATION}-question-3`] === 'Yes');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${CONTENT_ASSESSOR_REGISTRATION}-question-3`] !== 'Yes');
                        return result;
                    }
                },
                textRows: 4,
                span: 12
            },
            {
                id: 'attachments',
                label: 'Attachment Upload',
                type: 'file',
                category: 'SupportingDocuments',
                fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    // 'text/plain',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    // 'image/gif',
                    'image/bmp',
                    'video/quicktime',
                    'video/mp4',
                    'video/mpeg'
                ],
                span: 6
            },
            {
                id: 'link-to-attachments',
                label: 'Link to Supporting Documents',
                type: 'url',
                labelNote: 'For files greater than 10MB or in a different file type, you may provide a link. e.g. Dropbox, GoogleDrive.',
                span: 6
            }
        ]
    }
];
